<template>
  <div
    class="game-preview contest-box-inner"
    :class="{'stick-top': showingWithContest}">
    <loading-state :state="state"></loading-state>
    <div class="head loader" v-if="state.isLoaded()">
      <div class="left">
        <h3 class="sub-title">
          <router-link :to="{name: 'FCPreviewGame', params:{key: lcontest.key, gameKey: game.key}}"> {{game.name}}</router-link></h3>
        <router-link :to="{name: 'FCEditGame', params:{key: lcontest.key, gameKey: game.key}}" class="change-btn right-part">Edit</router-link>
        <div class="closetime" v-if="lpreview">
          <b>{{lpreview.game.closesAt | relativeShortDateTime}}</b><span> (Closing time)</span>
        </div>
        <p class="desc" v-if="game.desc">{{game.desc}}</p>
      </div>
    </div>
    <div class="content"  v-if="state.isLoaded()">
      <div class="matches">
        <h5 class="match top-space">Matches</h5>
        <div
          v-for="match in lpreview.matches"
          :key="match.match.key"
          class="match-mini"
        >
          <a class="clean" :href="match.match.link" target="window">
            <div class="teams">
              <div class="team">{{match.match.title}}</div>
            </div>
          </a>
          <div class="info">
            <b class="time">{{match.match.startAt | relativeShortDateTime}}</b>
            <p class="subtitle silent top-space">{{match.match.subtitle}} - {{match.match.season_name}}</p>
          </div>
        </div>
      </div>
      <ParticipantsPreview :preview="lpreview"/>
    </div>
  </div>
</template>
<script>
import { DataState } from '@/state'
import { GamePreview } from '@/models/fantasygame/core'
import ParticipantsPreview from '@/components/fantasygame/ParticipantsPreview'

export default {
  components: {
    ParticipantsPreview
  },
  props: {
    'contest': Object,
    'game': Object,
    'preview': Object,
    'showingWithContest': {
      type: Boolean,
      default: true
    },
    'lazyLoad': {
      type: Boolean,
      default: true
    }
  },

  data () {
    return {
      lpreview: null,
      lcontest: null,
      state: DataState.newNotInit(),
      playState: DataState.newNotInit(),
      observer: null,
      intersected: false
    }
  },

  mounted () {
    if (this.lazyLoad && !this.preview) {
      this.setupLazyLoading()
    } else {
      this.fetchData()
    }
  },
  destroyed () {
    if (this.observer) {
      this.observer.disconnect()
    }
  },
  methods: {
    setupLazyLoading () {
      this.observer = new IntersectionObserver(entries => {
        if (this.intersected) { return }
        const firstEntry = entries[0]
        if (firstEntry.isIntersecting) {
          this.intersected = true
          this.observer.disconnect()
          this.onElementVisible()
        }
      })

      this.$nextTick(() => {
        if (this.observer) {
          this.observer.observe(this.$el)
        }
      })
    },

    fetchData () {
      this.state.changeToLoading()
      this.lcontest = this.contest

      if (this.preview) {
        this.lpreview = this.preview
        this.state.changeToLoaded()
      } else {
        GamePreview.fetch(this.game.key).then((resp) => {
          this.lpreview = resp
          if (!this.lcontest) {
            this.lcontest = this.lpreview.contest
          }
          this.state.changeToLoaded()
        }).catch((error) => {
          this.state.changeToError(error)
        })
      }
    },

    onElementVisible () {
      if (this.state.isNotInit()) {
        this.fetchData()
      }
    }
  }
}
</script>
